import { Icon } from '@timeedit/ui-components';
import { Space, notification } from '@timeedit/ui-components/antd';
import type { NotificationInstance } from '@timeedit/ui-components/antd/notification/interface';

let notificationApi: NotificationInstance | null = null;

export const registerNotificationApi = (api: NotificationInstance) => {
  notificationApi = api;
};

// Fallback to static notification if API is not yet registered
const getNotificationApi = () => notificationApi || notification;

export function errorNotification(
  message: string,
  descriptionMessages?: string[]
) {
  const description = !descriptionMessages?.length ? undefined : (
    // Space is inline-flex, so without a width it sizes to max-content and a
    // long unbroken word escapes the notice padding instead of wrapping.
    <Space direction="vertical" style={{ width: '100%' }}>
      {descriptionMessages}
    </Space>
  );

  getNotificationApi().error({
    message,
    description,
    icon: <Icon id="Error" alt="Error icon" />,
    duration: 0,
  });
}

export function successNotification(
  message: string,
  descriptionMessages?: string[]
) {
  const description = !descriptionMessages?.length ? undefined : (
    <Space direction="vertical">{descriptionMessages}</Space>
  );

  getNotificationApi().success({
    message,
    description,
    icon: <Icon id="Success" alt="Success icon" />,
    duration: 0,
  });
}
